import { columnTypes } from '@/services/Grid/ColumnTypes';
import riskhub from "@/services/Riskhub/Riskhub";
import { cloneDeep, startCase, toLower } from 'lodash';
import ShowPropertyAssetsPhotos from "@/components/Grid/Renderers/ShowPropertyAssetsPhotos";

function FormatToEuDate({ value }) {
  return riskhub.formatDate(value);
}

function PropertyAssetType({ value }) {
  return value.parent ? value.parent.propertyAssetType : value.propertyAssetType;
}

/* Client Actions */
export const propertyAssetsGridDefaultColDef = {
  filter: 'agSetColumnFilter',
  resizable: true,
  sortable: true,
  filterParams: {
    selectAllOnMiniFilter: false,
  },
};

export const propertyAssetsGridColumnTypes = columnTypes;

const grid = [
  {
    headerName: 'ID',
    enablePivot: true,
    field: 'propertyAssetId',
    colId: 'propertyAssetId',
    width: 100,
    minWidth: 100,
    filter: 'agSetColumnFilter',
    checkboxSelection: true,
    headerCheckboxSelection: true,
    headerCheckboxSelectionFilteredOnly: true,
    sort: 'asc',
    aggFunc: 'count',
    enableValue: true,
  },
  {
    headerName: 'Asset Number',
    enablePivot: true,
    enableRowGroup: true,
    field: 'tagRef',
    colId: 'tagRef',
    width: 170,
    minWidth: 170,
  },
  {
    headerName: 'Flat Reference',
    enablePivot: true,
    enableRowGroup: true,
    field: 'flatRef',
    colId: 'flatRef',
    width: 170,
    minWidth: 170,
  },
  {
    headerName: 'Asset Type',
    enablePivot: true,
    enableRowGroup: true,
    field: 'type',
    colId: 'type',
    width: 175,
    minWidth: 175,
    cellRenderer: PropertyAssetType,
  },
  {
    headerName: 'Asset Sub Type',
    enablePivot: true,
    enableRowGroup: true,
    field: 'type.propertyAssetType',
    colId: 'type.propertyAssetType',
    width: 200,
    minWidth: 200,
  },
  {
    headerName: 'Asset Floor',
    enablePivot: true,
    enableRowGroup: true,
    field: 'floorNumber',
    colId: 'floorNumber',
    width: 150,
    minWidth: 150,
  },
  {
    headerName: 'Asset Flat Number',
    enablePivot: true,
    enableRowGroup: true,
    field: 'flatNumber',
    colId: 'flatNumber',
    width: 150,
    minWidth: 150,
  },
  {
    headerName: 'Asset Location',
    enablePivot: true,
    enableRowGroup: true,
    field: 'locationInformation',
    colId: 'locationInformation',
    width: 150,
    minWidth: 150,
  },
  {
    headerName: 'Created',
    enablePivot: true,
    enableRowGroup: true,
    field: 'createdDate',
    colId: 'createdDate',
    width: 150,
    minWidth: 150,
    cellRenderer: FormatToEuDate,
  },
  {
    headerName: 'Last Modified',
    enablePivot: true,
    enableRowGroup: true,
    field: 'updatedDate',
    colId: 'updatedDate',
    width: 150,
    minWidth: 150,
    cellRenderer: FormatToEuDate,
  },
  {
    headerName: 'Photos',
    field: '',
    colId: 'photos',
    width: 150,
    minWidth: 150,
    cellClass: 'overflow-cell',
    cellRendererFramework: ShowPropertyAssetsPhotos,
  },
];

export const propertyAssetsGridColumns = grid;

export const queryGridColumns = [
  {
    headerName: 'Query With',
    enablePivot: true,
    enableRowGroup: true,
    field: 'queryUser',
    colId: 'queryUser',
    width: 150,
    minWidth: 150,
    filter: 'agSetColumnFilter',
  },
];

export const getPropertyAssetsGridColumns = () => cloneDeep(propertyAssetsGridColumns);
